import { apmCaptureError } from '../apm'

import { ProcessEnvError } from './ProcessEnvError'

export const processEnvAccessorGetGlooApiUrlForClient = (): string => {
  const glooApiPath = process.env.GLOO_API_URL_FOR_CLIENT

  if (!glooApiPath) {
    throw new Error('missing_env_GLOO_API_URL_FOR_CLIENT')
  }

  return glooApiPath
}

export const processEnvAccessorGetGlooApiUrlForServer = (): string => {
  const glooApiHost = process.env.GLOO_API_URL_FOR_SERVER

  if (!glooApiHost) {
    throw new Error('missing_env_GLOO_API_URL_FOR_SERVER')
  }

  return glooApiHost
}

export const processEnvAccessorGetPicsApiUrlForServer = (): string => {
  const picsApiHost = process.env.PICS_API_URL_FOR_SERVER

  if (!picsApiHost) {
    throw new Error('missing_env_PICS_API_URL_FOR_SERVER')
  }

  return picsApiHost
}

export const processEnvAccessorGetDeploymentStage = (): NonNullable<
  typeof process.env.DEPLOYMENT_STAGE
> => {
  const deploymentStage = process.env.DEPLOYMENT_STAGE

  if (!deploymentStage) {
    throw new Error('missing_env_DEPLOYMENT_STAGE')
  }

  return deploymentStage
}

export const processEnvAccessorGetRetailMediaAdServerWidgetUrl = (): string => {
  return process.env.RETAIL_MEDIA_AD_SERVER_WIDGET_URL
}

export const processEnvAccessorGetAlgoliaApiKey = (): string => {
  const value = process.env.ALGOLIA_API_KEY
  if (!value) {
    apmCaptureError(new ProcessEnvError('ALGOLIA_API_KEY'))

    return ''
  }

  return value
}

export const processEnvAccessorGetOnlineDoctorBaseUrl = (): string => {
  const value = process.env.ONLINE_DOCTOR_BASE_URL
  if (!value) {
    throw new Error('missing_env_ONLINE_DOCTOR_BASE_URL')
  }

  return value
}

export const processEnvAccessorGetOnlineDoctorClientSrc = (): string => {
  const value = process.env.ONLINE_DOCTOR_CLIENT_SRC
  if (!value) {
    throw new Error('missing_env_ONLINE_DOCTOR_CLIENT_SRC')
  }

  return value
}

export const processEnvAccessorGetErxManagerSrc = (): string => {
  const value = process.env.ERX_MANAGER_SRC
  if (!value) {
    throw new Error('missing_env_ERX_MANAGER_SRC')
  }

  return value
}

export const processEnvAccessorErxManagerBaseUrl = (): string => {
  const value = process.env.ERX_MANAGER_BASE_URL
  if (!value) {
    throw new Error('missing_env_ERX_MANAGER_BASE_URL')
  }

  return value
}

export const processEnvAccessorGetErxManagerScanBotKey = (): string => {
  const value = process.env.ERX_MANAGER_SCAN_BOT_KEY
  if (!value) {
    throw new Error('missing_env_ERX_MANAGER_SCAN_BOT_KEY')
  }

  // The value of the environment variable might contain escaped newline characters (e.g., '\\n') that need to be replaced with actual newline characters ('\n') for the ScanBot key to work correctly.
  return value.replaceAll(String.raw`\n`, '\n').trim()
}

export const processEnvAccessorGetAlgoliaApplicationId = (): string => {
  const value = process.env.ALGOLIA_APPLICATION_ID
  if (!value) {
    apmCaptureError(new ProcessEnvError('ALGOLIA_APPLICATION_ID'))

    return ''
  }

  return value
}

export const processEnvAccessorGetStoryblokAccessToken = ():
  string | undefined => {
  return process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN
}

export const processEnvAccessorGetStoryblokCacheServiceUrl = ():
  string | undefined => {
  return process.env.STORYBLOK_CACHE_SERVICE_URL
}

export const processEnvAccessorGetRetailMediaAlgoliaProxyClientUrl =
  (): string => {
    const value = process.env.RETAIL_MEDIA_ALGOLIA_PROXY_CLIENT_URL

    if (!value) {
      throw new ProcessEnvError(
        'Missing environment variable: RETAIL_MEDIA_ALGOLIA_PROXY_CLIENT_URL. This variable is required to configure the Retail Media Algolia Proxy URL for the request made from client side.',
      )
    }

    return value
  }

export const processEnvAccessorGetRetailMediaAlgoliaProxyServerUrl =
  (): string => {
    const value = process.env.RETAIL_MEDIA_ALGOLIA_PROXY_SERVER_URL

    if (!value) {
      throw new ProcessEnvError(
        'Missing environment variable: RETAIL_MEDIA_ALGOLIA_PROXY_SERVER_URL. This variable is required to configure the Retail Media Algolia Proxy URL for the request made from server side.',
      )
    }

    return value
  }

export const processEnvAccessorGetAzDirectBaseUrl = (): string => {
  const value = process.env.AZ_DIRECT_BASE_URL

  if (!value) {
    throw new ProcessEnvError(
      'Missing environment variable: AZ_DIRECT_BASE_URL. This variable is required to configure the AZ Direct address suggestion service base URL.',
    )
  }

  return value
}

export const processEnvAccessorGetWifiInternalIpRange = (): string => {
  const value = process.env.WIFI_INTERNAL_IP_RANGE

  if (!value) {
    apmCaptureError(new ProcessEnvError('WIFI_INTERNAL_IP_RANGE'))

    return ''
  }

  return value
}

export const processEnvAccessorGetOfflineOrderServiceBasicAuth = (): {
  password: string
  username: string
} => {
  const username = process.env.BASIC_AUTH_OOS_USERNAME
  const password = process.env.BASIC_AUTH_OOS_PASS

  if (!username || !password) {
    throw new Error(
      'missing_env_BASIC_AUTH_OOS_USERNAME_or_BASIC_AUTH_OOS_PASS',
    )
  }

  return { password, username }
}
